import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import classes from "./header.module.css";
import { useSelector } from "react-redux";
import EyeSpyFXLogo from '../../../assets/eyespyfx-logo.png';
import ParfasLogo from "../../../assets/parfas-logo.png"
import ResureLogo from "../../../assets/resure-logo.png"
import KnowioLogo from "../../../assets/knowio-logo.png"
import PortalLogo from "../../../assets/portal-logo.png"
import NotificationDropDownList from "../Cards/NotificationDropDownList";
import NotificationBell from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Header/__Notifications.svg"

import { Link, useLocation } from "react-router-dom";
import Modal from "../../Modal/Modal";
import SetTag from "../../Modal/ModalLayouts/SetTag";
import { Audio, BallTriangle, Bars, Circles, Grid, Hearts, Oval, Puff, Rings, SpinningCircles, TailSpin, ThreeDots } from "react-loading-icons";
import { changeCamectIntegration, getGroups } from "../../../Api Methods/Api";
import { authActions } from "../../../store/auth-Slice";
import { useNavigate } from "react-router-dom";
import { serviceActions } from "../../../store/service-Slice";
import DataManager from "../../../hooks/DataManager";
import { single } from "rxjs";
import logoutIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/logout.png'
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import AddPortalUser from "../../../Pages/Groups/AddPortalUser";
import { Dropdown } from 'primereact/dropdown';
import Lottie from "lottie-react";
import successAnim from '../../../assets/animations/success.json'
import failAnim from '../../../assets/animations/fail.json'
import CreateUserForm from "../../../Pages/User Management/CreateUserForm";
import CreateUser from "../../../Register/CreateUser";
import CreateUserPortal from "../../../Register/CreateUserPortal";


const pages = ["Dashboard", "AllSites", "Offline", "Users", "Groups", "Padlocks", "Keyboxes", "Sensors", "UserSites", "Activity", "SiteView"];


const Header = ({ isSocketConnected, findClosestToEnd }) => {
    const companyName = useSelector(state => state.auth.companyName);
    const [visible, setIsVisible] = useState(false)
    const [addUserStep1Visible, setAddUserStep1Visible] = useState(false)
    const [addUserStep2Visible, setAddUserStep2Visible] = useState(false)
    const [groups, setGroups] = useState([])
    const [selectedGroup, setSelectedGroup] = useState(null)
    const [groupID, setGroupID] = useState(null)

    const [successVisible, setSuccessVisible] = useState(false)
    const [failVisible, setFailVisible] = useState(false)
    const [createUserVisible, setCreateUserVisible] = useState(false)

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const [update, setUpdate] = useState(0);

    const apiData = {
        token,
        client
    }

    const dataManager = new DataManager();

    const singleDeviceHeaderData = useSelector(state => state.service.singleDeviceHeaderData);
    const [headerData, setHeaderData] = useState(singleDeviceHeaderData);

    const dispatch = useDispatch();

    useEffect(() => {
        setHeaderData(singleDeviceHeaderData);
    }, [singleDeviceHeaderData, update])

    const ModalDialog = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    const userName = useSelector(state => state.auth.userName);
    const userEmail = useSelector(state => state.auth.email);


    const userID = useSelector(state => state.auth.userID);

    const navigate = useNavigate();

    const location = useLocation();
    const pathArray = location.pathname.split('/');
    const currentpage = findClosestToEnd(pages, pathArray);
    let header;
    switch (currentpage) {

        case "Users":
        case "Activity":
        case "UserSites":
           
            break
        case "Dashboard":
            
            break
        case "AllSites":
            
            break
        case "Offline":
            
            break
        case "Groups":
            
            break
        case "Padlocks":
            
            break
        case "Sensors":
            
            break
        case "Keyboxes":
           
            break
        
        case "SiteView":
            
            break
    }

    const LoadGroups = async () => {
        const _groups = await getGroups(apiData, dispatch)
        setGroups([..._groups].sort((a, b) =>
            a.name.localeCompare(b.name)
        ))
    }

    useEffect(() => {  
        LoadGroups()
    }, [])

    const HandleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(serviceActions.resetFilters())
        dispatch(serviceActions.resetGSFilters())
        navigate('/logout')
    }

    const handleReportAnIssue = () => {
        window.open("https://support.inniovate.com/portal/en/newticket", "_blank");
    }

    const HandleWhatsNew = () => {
        setIsVisible(true)
    }

    const HandleAddUser = () => {
        setAddUserStep2Visible(true)
    }

    const HandleChooseGroup = () => {
        setAddUserStep1Visible(true)
    }

    const changelogs = [
        {
            date: "Sep 25th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <ul className="list-disc pl-5">
                    <li><strong>Mass User Creation:</strong> Upload a <code>.csv</code> file to quickly create multiple user accounts.</li>
                    <li><strong>User Onboarding Details:</strong> Profiles will now indicate whether the user joined via self-registration, an invite, or admin creation.</li>
                    <li><strong>Dashboard Improvements:</strong> Dashboard items now show an 'Active count' to compare devices on an 'active' site vs total count.</li>
                    <li><strong>Improved visibility & tracking:</strong>  
                        <ul className="list-disc pl-5">
                            <li>From now on, newly added <em>Scheduled Actions, Reminders, Site Access Restrictions, and Temporary schedules</em> will display 'Created by' and 'Date created'.</li>
                            <li>Newly added 'Devices' (AJAX, Dahua, Hikvision and AIBox) will now display 'Added by' and 'Date added' details.</li>
                        </ul>
                    </li>
                    <li><strong>User Management Enhancements:</strong>  
                        <ul className="list-disc pl-5">
                        <li>Ability to edit user names and email addresses.</li>
                        <li>Default page size on <em>Users</em> page increased to 100.</li>
                        </ul>
                    </li>
                    </ul>

                    <br></br>

                    <h3>🛠️ Improvements</h3>
                    <ul className="list-disc pl-5">
                    <li><em>Create Scheduled Action</em> now displays the pin name instead of using a clickable button.</li>
                    <li><em>Users</em> page updated: “Last logged in” column has been replaced with “Account created”.</li>
                    <li><em>Controllers</em> & <em>Offline controllers</em> page updated: Count values can now be clicked to filter the list.</li> 
                    </ul>

                    <br></br>

                    <h3>🐞 Fixes</h3>
                    <ul className="list-disc pl-5">
                    <li>Fixed logo rendering issue in the sidenav bar.</li>
                    <li>Fixed Active switch behavior on <em>Controllers</em> and <em>Offline Controllers</em> pages.</li>
                    </ul>
                </div>
            )
        },
        {
            date: "Oct 13th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li>   Introduced new <em>'Padlock/Keybox' entity</em> page - View detailed padlock information and configuration by clicking on a Padlock/Keybox in the <em>Padlocks</em> or <em>Keybox</em> pages </li>
                    <li>   Introduced new <em>Scheduled sites</em> page - View which sites are on schedule & up to 4 schedules per site!</li>
                    <li>   <em>App View :</em> Added 'Gateway' logo & battery level to the App View to match mobile app UI</li>
                    <li>   Added the ability to name a Padlock or Keybox, outside of the output name.</li>
                    <li>   Improved billing 
                         <ul className="list-disc pl-5">
                            <li>        • Added the ability to set a Padlock or Keybox as billable or non-billable.</li>
                            <li>        • Added the ability to assign an owner and specify who pays for each Padlock/Keybox</li>
                            <li>        • Added new billable counts for Padlocks and Keyboxes in the <em>Dashboard</em> and <em>Group</em> pages, to quickly see how many Padlocks/Keyboxes are being paid for</li>
                        </ul>
                    </li>

                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>    Sites set to 'Inactive' will no longer receive Smart Reminders or Scheduled Actions</li>
                    <li>    Made all pop-ups moveable by clicking and dragging on the top</li>
                    <li>    Updated table columns on <em>Padlocks</em> & <em>Keybox</em> lists</li>
                        <ul className="list-disc pl-5">
                            <li>    • "Owned by" column has been renamed to "Used by"</li>
                            <li>    • "Lock name" column now shows internal name assigned to a Padlock/Keybox, "Linked output" will show the name of the output the lock is assigned to.</li>
                            <li>    • Battery status "0%" is now displayed as "?" to match the mobile app.</li>
                        </ul>
                    <li>    Updated the text in the 'Create user' dropdown for clearer options.</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                        <li>    Fixed an issue with <em>Rules</em> page, where removing a 'Scheduled Action' would cause the list to display in the wrong order</li>
                        <li>    Fixed an issue where the maximum length of a 'Duration' pincode would not be displayed before attempting to create</li>
                </div>
            )
        },
        {
            date: "Oct 26th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li>   The Portal now supports multi-tab browsing!</li>
                    <ul> You can right-click on a Site ID, Portal tab or Lock ID to open it in a new browser tab for easier multitasking</ul>
                    <li> Added ability to mass update Padlock owners from the Padlocks tab</li>
                    <li> Added ability to export Padlocks & Keyboxes to an excel file</li>
                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>   Added clickable link to Lock ID on Devices page, for easier navigation to Padlock page.</li>
                    <li>   Added new search & filtering options to Padlocks & Keyboxes page.</li>
                    <li>   Resolved layout issues on the Rules page for better display on smaller screens.</li>
                    <li>   Resolved layout issues with the Side nav bar for easier navigation on smaller screens</li>
                    <li>   Resolved layout issues with the Padlocks/Keyboxes/Sensors/Gateways lists on smaller screens</li>
                    <li>   Added IP Address/Site Type to user sites list</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li>    Fixed an issue preventing passcode creation on Padlocks.</li>
                    <li>    Fixed a bug where bookmarking the Portal could cause it to crash on launch.</li>
                </div>
            )
        },
        {
            date: "Nov 17th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li>   Added the ability to edit schedules from the <em>Scheduled sites</em> page!</li>
                    <ul> Simply click on an Arm or Disarm schedule to edit the execution time & days</ul>
                    <li> Added 'Last update' date to edited schedules to easily keep track of which have been modified already</li>
                    <li>   Added new <em>Live view enabled</em> page!</li>
                    <ul> Easily view sites with cameras linked, as well as when they were linked & by whom!</ul>
                    <li> Added Inniovate only Live View switch to allow setting of Live View licence per site</li>
                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>   Greyed out inactive sites on site lists to easily distinguish those that are active</li>
                    <li>   Changed app view icon to 'Settings cog' instead of Pencil</li>
                    <li>   Resolved layout issues on the Rules page for better display on smaller screens.</li>
                    <li>   Added linked camera count to Overview page of Live View enabled sites</li>
                    <li>   Added Live View stats to Dashboard & Group Dashboards - count of Live View enabled sites & no. of cameras linked</li>
                    <li>   Added camera & site counts to new <em>Live view enabled</em> page</li>
                    <li>   Updated <em>Scheduled sites</em> page to allow filtering by day of execution</li>
                    <li>   Changed 'Holiday mode' to 'Temporary Schedules' throughout</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li>    Fixed an issue with selecting page size on site event logs.</li>
                    <li>    Fixed an issue where G2CC sites showed as 'Physical Controller' on Overview page</li>
                    <li>    Fixed an issue where some duration codes didn't display the end date & which pin type was created</li>
                    <li>    Fixed issue with Portal name not updating on App UI after 1st change</li>
                    <li>    Fixed issue with Reminders showing as a Schedule</li>
                    <li>    Fixed issue with create mass/individual temporary schedule</li>
                </div>
            )
        },
        {
            date: "Nov 25th, 2025",
            content: (
                <div className="space-y-4">
                     <h3>✨ New Features</h3>
                    <li>   Ganz AiBox V2 is here!</li>
                    <ul> You can now control your Ganz AiBox Channels, Rules, Relays or the whole Hub!</ul>
                    <li>   Added new 'Give Portal access' button to the header bar to easily grant access to the Portal</li>
                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>   Completely reworked Active Sites, Inactive Sites, Controllers & Sites on schedule to reduce load times and increase responsiveness</li>
                    <li>   Updated 'Add to group' dropdown menus. They're now searchable with an improved UI</li>
                    <li>   Account username & email address is now displayed in the header bar</li>
                    <li>   Reworked Live view enabled page to be site orientated</li>
                    <li>   Added ability to click on 'Camera count' on Live view sites to show list of linked cameras</li>
                    <li>   Redesigned Devices & Rules layouts due to rendering issues</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li>    Fixed an issue with incorrect error messages being shown when inviting a user</li>
                    <li>    Fixed an issue with searching on the Active & Inactive sites tab</li>
                   <li>     Fixed an issue with duplicate schedules appearing after creating a 'Temporary schedule'</li>
                </div>
            )
        },
        {
            date: "Dec 17th, 2025",
            content: (
                <div className="space-y-4">
                     <h3>✨ New Features</h3>
                    <li> Super Rules are here!</li>
                    <ul> You can now create rules to affect other sites, perform different actions on outputs & choose days of the week or hours of the day on which the rule executes! You can also click on a Super Rule to view it or add/remove actions</ul>
                    <li> New search features on <em>All Sites</em> & <em>Group sites</em></li>
                    <ul> You can now deep dive into sites, filter by linked devices, Group, schedules, live view status & much more! Click on the filter icon on the search bar to get started</ul>
                    <li> Temporary users!</li>
                    <ul> You can now add access expiry dates to user invites, so they will be automatically removed when the time comes</ul>
                    <li> Hikvision!</li>
                    <ul> You can now add/remove Hikvision devices from G2CC sites</ul>
                    <li> Live View!</li>
                    <ul> You can now add/remove Live View cameras to Live View enabled sites</ul>
                    <ul> </ul>

                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li> Search & filter options are now stored when you enter/exit a site on <em>All Sites</em> page</li>
                    <li> Number of linked cameras is now displayed on the 'All Sites' list</li>
                    <li> Redevelopment of the Group sites page, to massively decrease load times & added the new advanced filtering options</li>
                    <li> S/O is displayed on the 'All Sites' list for sites that are 'Schedule Only'</li>
                    <li> Redeveloped the 'Create Group' feature to be more responsive</li>
                    <li> Tidyied up filter dropdowns throughout Portal</li>
                    <li> Improved the Group selection dropdown throughout, to be more responsive & searchable</li>

                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li> Fixed an issue with users not being displayed when viewing a groups Portal users</li>
                    <li> Fixed an issue with refreshing the page while viewing a group's sites causing the site to crash</li>
                    <li> Fixed an issue with opening a site which had 0 active switches</li>
                    <li> Fixed loading issue on Devices page when a Ganz AIBox was linked</li>

                </div>
            )
        },
        {
            date: "Jan 26th, 2026",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li>CCTV Status!</li>
                    <ul>Added new 'traffic light' indicators to CCTV systems. When a 3rd party device linked to a G2CC site is unreachable for 10 minutes its status will become yellow, if it's still not reachable after 20 minutes it becomes amber, 30 or more minutes it becomes red.</ul>
                    <ul>Easily find problematic sites by applying the new 'Only show CCTV systems with connection issues' filter on both <em>All sites</em> & <em>3rd party CCTV</em> tabs </ul>
                    <ul>Output status icons will now reflect CCTV connection status. if unstable, the warning icon will replace the output status on site lists</ul>
                    <li> AJAX! </li>
                    <ul> Added ability to link AJAX devices on Portal</ul>
                    <li> Dahua!</li>
                    <ul> Added ability to add Dahua devices on Portal </ul>
                    <li> Site location & type</li>
                    <ul> Added ability to set a sites location & type, these can then be used as filters on the <em>Scheduled sites</em> & <em>Temporary schedules</em> pages, for easier management of schedules</ul>
                    

                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li> Mass upload options now have template .csv files available to download</li>
                    <li> Redesigned 'Mass create user' & 'Mass invite user' pop-ups to be more informative when the process is executing.</li>
                    <li> Added the ability to 'Mass invite users' from within the site on the <em>Users</em> tab</li>
                    <li> Added ability to change a users role to 'Manager plus' using the settings cog as well as the mass action dropdown menu </li>
                    <li> Changed default <em>Users</em> page size to 50 & increased page size options to 20, 50, 100</li>
                    <li> Added pencil icon to items that are editable on <em>Overview</em> page & <em>Users</em> tab</li>
                    <li> Added 'Controlled by' & 'Controlling' hyperlinks to sites which use new Super rules, for easier naviagtion between Parent & Child sites</li>
                    <li> Updated Super rule UI on <em>Devices</em> page to show which site is being controlled by the rule</li>
                    <li> Super rules are now displayed on both Parent & Child sites for better understanding of whats affecting the site</li>
                    <li> Added new filter to only show 'Live view enabled' sites that either have or don't have a camera linked</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li> Fixed an issue with 'Viewable by standard user' switch showing the incorrect status when editing an output</li>
                    <li> Fixed an issue with both 'LATCH' & 'PULSE' showing as selected when editing an output</li>
                    <li> Fixed an issue with readability on registration forms</li>
                    <li> Fixed an issue with inputs 1, 2, 3 & 4 not being availble to link on virtual devices</li>
                </div>
            )
        },
         {
            date: "March 30th, 2026",
            content: (
                <div className="space-y-4">
                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li> Redesigned Gateway, Padlock & Keybox battery & signal indicators on lists & 'Devices' tiles</li>
                    <li> Changed 'Last updated' text to red, for easier identification of problem Gateways</li>
                    <li> Added 'Last updated' date to Padlocks & Keyboxes, for clearer representation of battery levels</li>
                    <li> Added 'Counts' such as 'Low battery/Daily poll missed' to Gateways, Padlocks & Keyboxes tab, for easier identification of issues</li>
                    <li> Updated App UI to only show active outputs & inputs</li>
                    <li> Added new filtering options to Gateways, you can now filter by battery level, signal strength & more</li>
                    <li> Redesigned popups & buttons throughout Portal</li>
                    <li> Updated loading animations of Dashboard, Rules, Devices & Logs</li>
                    <li> Added confirmation of success/failure popups to various actions throughout Portal</li>
                    <li> Added hyperlink to users in Site users tab & Site event logs, to allow quick viewing of the users profile</li>
                    <li> Added new 'Refresh' button to site event logs & removed caching - logs will now reload each time the tab is opened</li>
                    <li> Added ability grant admin access to a user while creating their account</li>

                    <br></br>


                    <h3>🐞 Fixes</h3>
                    <li> Fixed an issue with 'Create Portal User' form showing white text on a white background'</li>
                    <li> Fixed an issue with exporting event logs showing irrelevant data</li>
                    <li> Fixed an issue with editing time values when creating/editing Schedules & Reminders</li>
                    <li> Fixed an issue allowing temporary schedule start date to be after end date</li>
                    <li> Fixed sizing issue with the Reset filters button on Group sites & All Sites</li>
                    <li> Fixed sizing issue with the 'Collapse App View' button</li>
                    <li> Fixed layout issue with the site name on App View overlapping the Site ID</li>
                    <li> Fixed an issue with exporting users to excel, only exporting the first 10</li>
                    <li> Fixed loading issue with Rules tab causing flickering/stuttering</li>
                    <li> Fixed an issue with 'Controlling ...' & 'Controlled by...' text staying above App View after deleting the Rule</li>
                    <li> Fixed an issue with creating more than 1 'Site access restriction'</li>
                    <li> Fixed an issue with deleting more than 1 Rule (new) </li>
                    <li> Fixed issue with pop-up size when viewing a Camect camera list</li>
                    <li> Fixed an issue with the Control Bar within a Site getting cut off when window size is reduced</li>
                </div>
            )
        },
        {
             date: "April 10th, 2026",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li><strong>Site Analytics</strong></li>
                    <ul>Introduced a new analytics section when viewing a site, providing deeper insights across three dedicated tabs: <em>User Analytics</em>, <em>Schedules</em>, and <em>Security</em>.</ul>
                    <li><strong>User Analytics:</strong>  
                        <ul className="list-disc pl-5">
                            <li>View activity based on selected output pin (with or without padlocks).</li>
                            <li>Analyse usage through bar charts, line graphs, and tables.</li>
                            <li>Identify top users and overall usage trends.</li>
                            <li>Filter data by time period (year, month, week).</li>
                            <li>Click users to open their individual pages and inspect logs.</li>
                        </ul>
                    </li>

                    <li><strong>Schedule Insights:</strong>  
                        <ul className="list-disc pl-5">
                            <li>Understand how effective your site schedules are.</li>
                            <li>View schedule failures using bar charts.</li>
                            <li>Track success rates with a doughnut chart.</li>
                            <li>Filter data by time period (year, month, week).</li>
                        </ul>
                    </li>

                    <li><strong>Security Monitoring:</strong>  
                        <ul className="list-disc pl-5">
                            <li>Monitor potential security concerns across your site.</li>
                            <li>Track invalid padlock PIN entries, gateway tampering, and forced padlock openings.</li>
                            <li>Visualised in a line graph for trend analysis.</li>
                        </ul>
                    </li>

                    <li><strong>User Activity:</strong>  
                        <ul className="list-disc pl-5">
                            <li><em>Users</em> tab has been split into 2 sub-tabs</li>
                            <li>View a list of all sites a user has access to</li>
                            <li>View a log of the users activity across their sites</li>
                        </ul>
                    </li>

                    <li><strong>Live View Sites:</strong>  
                        <ul className="list-disc pl-5">
                            <li>The <em>Live View</em> tab has now been split into 2 sub-tabs!</li>
                            <li>View a list of all your Live View enabled sites that have a camera linked</li>
                            <li>View a list of all your linked Live View Cameras & their associated sites</li>
                        </ul>
                    </li>

                    <br></br>
                
                    <h3>🛠️ Improvements</h3>
                   <li>Added a search bar to Live View sites </li>
                   <li>Updated Site 'Events' UI </li>
                   <li>Added ability to view linked Teltonika sensors in the 'Devices' tab</li>

                    <br></br>

                    <h3>🐞 Fixes</h3>
                    <li>Fixed an issue where a users account failed to display who invited them to the system</li>
                    <li>Fixed an issue with exporting users only exporting the first 10</li>

                </div>
            )
        }
    ]

    const [selected, setSelected] = useState(changelogs[8]);

    const HandleNext = () => {
        setGroupID(selectedGroup.id)
        setAddUserStep1Visible(false)
        setAddUserStep2Visible(true)
    }

    const HandleCreateUser = () => {
        setAddUserStep2Visible(false)
        setFailVisible(false)
        setCreateUserVisible(true)
    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Tag site - " + headerData.key} modalName={"Site View"} HandleShowModal={HandleShowModal}>
                <SetTag placeholder={headerData.key} DeviceUUID={headerData.uuid} HandleCloseModal={HandleCloseModal} dispatch={dispatch} update={update} setUpdate={setUpdate} isManualSet={true} headerData={headerData} setHeaderData={setHeaderData}/>
            </Modal>

        <Dialog
            header="Changelog"
            visible={visible}
            style={{ width: "60vw" }}
            onHide={() => setIsVisible(false)}
            >
            <div className="flex gap-4">
                {/* Sidebar selector */}
                <div className="flex flex-col gap-2 w-1/4 border-r pr-2">
                {changelogs.map((log) => (
                    <Button
                    label={log.date} 
                    severity="help"
                    outlined={selected.date !== log.date} 
                    rounded
                    key={log.date}
                    onClick={() => setSelected(log)}
                    style={{marginRight:"10px", marginBottom:"20px"}}
                    />
                    
                   
                ))}
                </div>

                {/* Content */}
                <div className="w-3/4 pl-4" style={{margin:"15px"}}>{selected.content}</div>
            </div>
        </Dialog>

        <Dialog
            header="Give Portal access"
            visible={addUserStep2Visible}
            style={{ width: "40vw" }}
            onHide={() => setAddUserStep2Visible(false)}
            >
            <div className="flex gap-4">
               <AddPortalUser setSuccess={setSuccessVisible} setFail={setFailVisible} groupID={groupID} setShowPrevDialogs={setAddUserStep2Visible} />
            </div>
        </Dialog>

        <Dialog
            header="Which group will they have access to?"
            visible={addUserStep1Visible}
            style={{ width: "40vw" }}
            onHide={() => setAddUserStep1Visible(false)}
            >
            <div>
            {/* Choose group */}
               <p>Choose group from the dropdown below</p>
               <Dropdown 
                value={selectedGroup} 
                onChange={(e) => setSelectedGroup(e.value)} 
                options={groups} 
                optionLabel="name"
                showClear
                filter
                placeholder="Select a group" 
                className="w-full md:w-14rem" />

            </div>

            <br></br>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button label="Next" severity="success" disabled={!selectedGroup} onClick={HandleNext} />
            </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>User added successfully!.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={failVisible}
            style={{ width: "40vw" }}
            onHide={() => setFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff", textAlign: "center"}}>Failed to add user, please try again.</h3>
     
            <p style={{color:"#6e6e6eff", textAlign: "center"}}>Please note, users must have an existing app account to be invited to the Admin Portal.</p>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 200, height: 200, margin: "0px" }}
                />

            <Button label="Close" rounded severity="primary" icon="pi pi-times"onClick={() => setFailVisible(false)}/>
                <br></br>
            <Button label="Create user?" icon="pi pi-info-circle" severity="secondary" onClick={HandleCreateUser}/>


            </div>
        </Dialog>

        <Dialog
            header="Give Portal access"
            visible={createUserVisible}
            style={{ width: "40vw" }}
            onHide={() => setCreateUserVisible(false)}
            >
            <div className="flex gap-4">
                <CreateUserPortal setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} setCreateAccountVisible={setCreateUserVisible} groupID={groupID} />
            </div>
        </Dialog>



            <div className={classes['header-container']}>
                <div className={classes.innerContainer}>
                    <div className={classes.container}>
                        <p style={{fontSize:"12px", color:"#6e6e6e"}}>{`Logged in as: ${userName}`}</p> 
                    </div>
                    <div className={classes.right} style={{cursor: "pointer", display: "flex", alignItems: "center", gap: "10px"}}>
                    {/* <Button severity="secondary" className={classes.headerButton} label="Report an issue" icon="pi pi-send" onClick={handleReportAnIssue}/> */}
                    <Button severity="info" className={classes.headerButton} label="Give Portal access" icon="pi pi-user-plus" onClick={HandleChooseGroup}/>
                    <Button severity="help" outlined className={classes.headerButton} label="What's new?" icon="pi pi-sparkles" onClick={HandleWhatsNew}/>
                    <Button severity="secondary" className={classes.headerButton} label="Logout" icon="pi pi-sign-out" onClick={HandleLogout}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;